import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CustomTextField } from 'esocial.web.react.lib/cjs/components/form/Custom/CustomTextField';
import ListaRegraValidacao from 'esocial.web.react.lib/cjs/components/form/Validation/ListaRegraValidacao';
import RegraCpf from 'esocial.web.react.lib/cjs/components/form/Validation/RegraCpf';
import RegraDiaMesAno from 'esocial.web.react.lib/cjs/components/form/Validation/RegraDiaMesAno';
import RegraObrigatoriedade from 'esocial.web.react.lib/cjs/components/form/Validation/RegraObrigatoriedade';
import { VepDatePicker } from 'esocial.web.react.lib/cjs/components/form/Vep/VepDatePicker';
import { VepSelect } from 'esocial.web.react.lib/cjs/components/form/Vep/VepSelect';
import { VepTextField } from 'esocial.web.react.lib/cjs/components/form/Vep/VepTextField';
import { ContentPreview } from 'esocial.web.react.lib/cjs/components/util/ContentPreview';
import { Display } from 'esocial.web.react.lib/cjs/components/util/Display';
import { Fieldset } from 'esocial.web.react.lib/cjs/components/util/Fieldset';
import IdentificacaoEvento from 'esocial.web.react.lib/cjs/components/util/IdentificacaoEvento';
import { TituloPagina } from 'esocial.web.react.lib/cjs/components/util/Text';
import { useRequisicaoControlada } from 'esocial.web.react.lib/cjs/hooks/RequisicaoControlada';
import { Mascara } from 'esocial.web.react.lib/cjs/utils/enums';
import { getStringValue, isUndefinedOrNull, obterObjetoTodosComponentesTocados, verificarTodosComponentesTocados } from 'esocial.web.react.lib/cjs/utils/geral';
import { Fragment, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Exames from './Exames';

const ContainerBotoesPagina = styled('div')(({ theme }) => ({
    '&': {
        marginTop: theme.spacing(6),
        display: 'flex',
        flexDirection: 'row-reverse',
    },
    '& > *': {
        marginLeft: theme.spacing(1)
    }
}));

const ContainerBotaoVoltar = styled('div')(({ theme }) => ({
    marginTop: theme.spacing(6),
    display: 'flex',
    flexDirection: 'row'
}));

function MonitoramentoSaudeRegistro({ visualizacao = false }) {
    const { idTrabalhador, idEvento, idContrato, tsv, admPreliminar } = useParams();
    const [modelo, setModelo] = useState(null);
    const [preencherInformacoesGrupoRespMonit, setPreencherInformacoesGrupoRespMonit] = useState(false);

    // Hook personalizado para requisições ao servidor
    const { get, post } = useRequisicaoControlada();
    const navigate = useNavigate();

    const processamentoResposta = (conteudoResposta) => {
        setModelo(conteudoResposta);

        // Atualizar o estado de preencherInformacoesGrupoRespMonit
        setPreencherInformacoesGrupoRespMonit(getStringValue(conteudoResposta.nomeMedicoResponsavel.valor).length > 0)
    };

    function voltarListagem() {
        navigate(`/monitoramentoSaude/${idTrabalhador}/${idContrato}/${tsv}/${admPreliminar}`);
    }

    // Estado de campos ainda não tocados pelo usuário e formulário ainda não submetido (usado no mecanismo de validações)
    const objetoComponentesTocados = {};

    objetoComponentesTocados['tipoExameOcupacional'] = false;
    objetoComponentesTocados['resultadoASO'] = false;
    objetoComponentesTocados['dataASO'] = false;
    objetoComponentesTocados['nomeMedicoASO'] = false;
    objetoComponentesTocados['numeroCRMASO'] = false;
    objetoComponentesTocados['ufCRMASO'] = false;
    objetoComponentesTocados['cpfMedicoResponsavel'] = false;
    objetoComponentesTocados['nomeMedicoResponsavel'] = false;
    objetoComponentesTocados['numeroCRMResponsavel'] = false;
    objetoComponentesTocados['ufCRMResponsavel'] = false;

    const [componenteTocadoFormulario, setComponenteTocadoFormulario] = useState(objetoComponentesTocados);

    // Construção das regras de validação para os campos do formulário
    const [regraValidacaoFormulario, setRegraValidacaoFormulario] = useState({});

    useEffect(() => {
        const objetoRegrasValidacao = {};

        if (modelo != null) {
            objetoRegrasValidacao['tipoExameOcupacional'] = new RegraObrigatoriedade(modelo.tipoExameOcupacional.valor, componenteTocadoFormulario['tipoExameOcupacional']);
            objetoRegrasValidacao['resultadoASO'] = new RegraObrigatoriedade(modelo.resultadoASO.valor, componenteTocadoFormulario['resultadoASO']);
            objetoRegrasValidacao['dataASO'] = new ListaRegraValidacao([new RegraObrigatoriedade(modelo.dataASO.valor), new RegraDiaMesAno(modelo.dataASO.valor)], componenteTocadoFormulario['dataASO']);
            objetoRegrasValidacao['nomeMedicoASO'] = new RegraObrigatoriedade(modelo.nomeMedicoASO.valor, componenteTocadoFormulario['nomeMedicoASO']);
            objetoRegrasValidacao['numeroCRMASO'] = new RegraObrigatoriedade(modelo.numeroCRMASO.valor, componenteTocadoFormulario['numeroCRMASO']);
            objetoRegrasValidacao['ufCRMASO'] = new RegraObrigatoriedade(modelo.ufCRMASO.valor, componenteTocadoFormulario['ufCRMASO']);

            // Grupo respMonit opcional (regido por preencherInformacoesGrupoRespMonit)
            objetoRegrasValidacao['cpfMedicoResponsavel'] = new RegraCpf(modelo.cpfMedicoResponsavel.valor, componenteTocadoFormulario['cpfMedicoResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao['nomeMedicoResponsavel'] = new RegraObrigatoriedade(modelo.nomeMedicoResponsavel.valor, componenteTocadoFormulario['nomeMedicoResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao['numeroCRMResponsavel'] = new RegraObrigatoriedade(modelo.numeroCRMResponsavel.valor, componenteTocadoFormulario['numeroCRMResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao['ufCRMResponsavel'] = new RegraObrigatoriedade(modelo.ufCRMResponsavel.valor, componenteTocadoFormulario['ufCRMResponsavel'] && preencherInformacoesGrupoRespMonit);
            objetoRegrasValidacao.todosComponentesTocados = verificarTodosComponentesTocados(componenteTocadoFormulario);
        }

        setRegraValidacaoFormulario(objetoRegrasValidacao);
    }, [modelo, componenteTocadoFormulario, preencherInformacoesGrupoRespMonit]);

    const [nomeFuncaoAcaoFormularioCompletamenteValidado, setNomeFuncaoAcaoFormularioCompletamenteValidado] = useState(null);

    useEffect(() => {
        async function processamentoInternoAssincrono() {
            const valoresValidacaoFormulario = Object.values(regraValidacaoFormulario).filter((x) => typeof x !== 'boolean');

            if (regraValidacaoFormulario.todosComponentesTocados) {
                if (typeof nomeFuncaoAcaoFormularioCompletamenteValidado === 'string' && valoresValidacaoFormulario.length > 0 && !new ListaRegraValidacao(valoresValidacaoFormulario).existeErro()) {
                    if (nomeFuncaoAcaoFormularioCompletamenteValidado === 'submeter') {
                        await post("/sst/monitoramentoSaude/salvar", modelo, voltarListagem);
                    }
                }

                setNomeFuncaoAcaoFormularioCompletamenteValidado(null);
            }
        }

        processamentoInternoAssincrono();
    }, [nomeFuncaoAcaoFormularioCompletamenteValidado, regraValidacaoFormulario.todosComponentesTocados]);

    function handleSubmit(e) {
        e.preventDefault();
        e.stopPropagation();

        setModelo({
            ...modelo,
            itemExameAuxiliar: {
                dataExame: { ...modelo.itemExameAuxiliar.dataExame, valor: null },
                codigoProcedimentoRealizado: { ...modelo.itemExameAuxiliar.codigoProcedimentoRealizado, valor: '' },
                ordemExame: { ...modelo.itemExameAuxiliar.ordemExame, valor: null },
                indicacaoResultados: { ...modelo.itemExameAuxiliar.indicacaoResultados, valor: null },
                observacaoProcedimento: { ...modelo.itemExameAuxiliar.observacaoProcedimento, valor: '' }
            }
        });

        setComponenteTocadoFormulario(obterObjetoTodosComponentesTocados(componenteTocadoFormulario));
        setNomeFuncaoAcaoFormularioCompletamenteValidado('submeter');
    }

    async function inicializarModelo(idEvento, idContrato, tsv) {
        // Registro
        if (isUndefinedOrNull(idEvento)) {
            await get(`sst/monitoramentoSaude/obterEvento/0/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
        // Visualização ou retificação
        else {
            await get(`sst/monitoramentoSaude/obterEvento/${idEvento}/${idContrato}/${tsv}/${admPreliminar}/${visualizacao}`, processamentoResposta);
        }
    }

    useEffect(() => {
        inicializarModelo(idEvento, idContrato, tsv);
    }, []);

    return (
        (modelo !== null && Object.values(regraValidacaoFormulario).length > 0) ?
            <Fragment>
                <TituloPagina>Monitoramento de Saúde</TituloPagina>
                <form id="formMonitoramentoSaude" onSubmit={(e) => handleSubmit(e)}>
                    <Fieldset legend="Identificação do Trabalhador" spacing={4}>
                        <VepTextField
                            accessor="cpfTrabalhador"
                            label="CPF"
                            model={modelo}
                            xs={12} md={3}
                            readOnly
                            maskPattern={Mascara.CPF}
                        />

                        <CustomTextField
                            xs={12} md={6}
                            label="Nome"
                            value={modelo.nome}
                            readOnly/>

                        <VepTextField
                            accessor="matricula"
                            label="Matrícula"
                            model={modelo}
                            xs={12} md={3}
                            readOnly
                        />
                    </Fieldset>

                    <VepSelect
                        accessor="tipoExameOcupacional"
                        label="Qual o tipo do exame médico ocupacional?"
                        model={modelo}
                        setModel={setModelo}
                        xs={12} md={12}
                        readOnly={visualizacao}
                        {...regraValidacaoFormulario['tipoExameOcupacional'].obterPropriedadesValidacao()}
                        onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'tipoExameOcupacional': true })}
                    />

                    <Fieldset legend="Dados do Atestado de Saúde Ocupacional (ASO)" spacing={4}>
                        <VepSelect
                            accessor="resultadoASO"
                            label="De acordo com o exame o trabalhador está apto?"
                            model={modelo}
                            setModel={setModelo}
                            xs={12} md={5}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['resultadoASO'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'resultadoASO': true })}
                        />

                        <VepDatePicker
                            accessor="dataASO"
                            label="Qual a data de emissão do atestado de saúde ocupacional?"
                            model={modelo}
                            setModel={setModelo}
                            xs={12} md={5}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['dataASO'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'dataASO': true })}
                        />

                        <VepTextField
                            accessor="nomeMedicoASO"
                            label="Nome do médico"
                            model={modelo}
                            setModel={setModelo}
                            xs={12} md={5}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['nomeMedicoASO'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'nomeMedicoASO': true })}
                        />

                        <VepTextField
                            accessor="numeroCRMASO"
                            label="Número do Conselho Federal de Medicina (CRM)"
                            model={modelo}
                            setModel={setModelo}
                            maxLength={8}
                            xs={12} md={5}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['numeroCRMASO'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'numeroCRMASO': true })}
                        />

                        <VepSelect
                            accessor="ufCRMASO"
                            label="UF do CRM"
                            model={modelo}
                            setModel={setModelo}
                            xs={12} md={2}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['ufCRMASO'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'ufCRMASO': true })}
                        />
                    </Fieldset>

                    <Exames modelo={modelo} setModelo={setModelo} somenteVisualizacao={visualizacao}></Exames>

                    <Fieldset legend="Médico que coordena o Programa de Controle Médico de Saúde Ocupacional - PCMSO" spacing={4}>
                        <VepTextField
                            accessor="cpfMedicoResponsavel"
                            label="CPF do Médico responsável/coordenador"
                            model={modelo}
                            setModel={setModelo}
                            xs={12} md={3}
                            maskPattern={Mascara.CPF}
                            maxLength={14}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['cpfMedicoResponsavel'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'cpfMedicoResponsavel': true })}
                        />

                        <VepTextField
                            accessor="nomeMedicoResponsavel"
                            label="Nome do médico"
                            model={modelo}
                            setModel={setModelo}
                            xs={12} md={6}
                            required={preencherInformacoesGrupoRespMonit}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['nomeMedicoResponsavel'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'nomeMedicoResponsavel': true })}
                        />

                        <VepTextField
                            accessor="numeroCRMResponsavel"
                            label="Número do Conselho Federal de Medicina (CRM)"
                            model={modelo}
                            setModel={setModelo}
                            maxLength={8}
                            xs={12} md={5}
                            required={preencherInformacoesGrupoRespMonit}
                            readOnly={visualizacao}
                            {...regraValidacaoFormulario['numeroCRMResponsavel'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'numeroCRMResponsavel': true })}
                        />

                        <VepSelect
                            accessor="ufCRMResponsavel"
                            label="UF do CRM"
                            model={modelo}
                            setModel={setModelo}
                            xs={12} md={3}
                            readOnly={visualizacao}
                            required={preencherInformacoesGrupoRespMonit}
                            {...regraValidacaoFormulario['ufCRMResponsavel'].obterPropriedadesValidacao()}
                            onBlur={() => setComponenteTocadoFormulario({ ...componenteTocadoFormulario, 'ufCRMResponsavel': true })}
                        />
                    </Fieldset>

                    <Display show={visualizacao}>
                        <IdentificacaoEvento idEventoXml={modelo.idEventoXml} numeroRecibo={modelo.numeroRecibo} />
                    </Display>

                    <Display show={visualizacao}>
                        <ContainerBotaoVoltar>
                            <Button variant="outlined" color="secondary" size="medium" onClick={() => navigate(-1)}>
                                Voltar
                            </Button>
                        </ContainerBotaoVoltar>
                    </Display>

                    <Display show={!visualizacao}>
                        <ContainerBotoesPagina>
                            <Button variant="contained" color="primary" size="medium" type="submit">
                                Salvar
                            </Button>
                            <Button variant="outlined" color="primary" size="medium" onClick={() => navigate(-1)}>
                                Cancelar
                            </Button>
                        </ContainerBotoesPagina>
                    </Display>
                </form>
            </Fragment > :
            <ContentPreview />
    );
}

export default MonitoramentoSaudeRegistro;
